<template>
	<div class="sk_objects_api">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">API接口</h1>
		<!-- <h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			SDK初始化是使用SDK的第一步，
			在该过程中完成向系统申请内存、加载人脸识别模型、授权等操作，首次授权需访问外网。
		</p> -->
		<!-- <h2 class="doc_main_h2">Android SDK初始化</h2> -->
		<h3 class="doc_main_h3">描述</h3>
		<p class="doc_main_p">SKEyeSDK调用者提供图片文件或者图片URL，进行图片分析，识别图片信息。</p>
        <h3 class="doc_main_h3">调用方法</h3>
        <p class="doc_main_p">POST</p>
		<h3 class="doc_main_h3">调用URL</h3>
		<h4 class="doc_main_h4">
			常见物品识别
		</h4>
		<p class="doc_main_p">
			https://api.sk-ai.com/objects/
		</p>
		<h4 class="doc_main_h4">
			水果识别
		</h4>
		<p class="doc_main_p">
			
			https://api.sk-ai.com/fruits/
		</p>
		<h4 class="doc_main_h4">
			植物识别
		</h4>
		<p class="doc_main_p">
			
			https://api.sk-ai.com/plant/
		</p>
		<h4 class="doc_main_h4">
			酒品识别
		</h4>
		<p class="doc_main_p">
			
			https://api.sk-ai.com/wine/
		</p>
		<h4 class="doc_main_h4">
			饮料识别
		</h4>
		<p class="doc_main_p">
			https://api.sk-ai.com/beverage/
		</p>
        <h3 class="doc_main_h3">请求参数</h3>
       	<div class="table_box">
			<template>		<!--:span-method="objectSpanMethod"-->
			    <el-table
				    :data="tableDataParameter"
				    :span-method="objectSpanMethodParameter"
				    border
				    style="width: 100%">
				      	<el-table-column
					        prop="code"
					        label="是否必填">
				      	</el-table-column>
				      	<el-table-column
				        	prop="key"
				        	label="参数名">
				        	<!-- <template scope="scope">
					    		<div class="table_msg">	
					    			{{scope.row.index}}
					    		</div>
					    	</template> -->
				      	</el-table-column>
				      	<el-table-column
				        	prop="type"
				        	label="类型">
				        	<!-- <template scope="scope">
					    		<div class="table_msg">	
					    			{{scope.row.msg}}
					    		</div>
					    	</template> -->
				      	</el-table-column>
				      	<el-table-column
				        	prop="msg"
				        	label="说明">
				        	<!-- <template scope="scope">
					    		<div class="table_msg">	
					    			{{scope.row.msg}}
					    		</div>
					    	</template> -->
				      	</el-table-column>
			    </el-table>
			</template>
		</div>
		<h3 class="doc_main_h3">返回值说明</h3>
		<div class="table_box">
			<template>		<!--:span-method="objectSpanMethod"-->
			    <el-table
				    :data="tableDataResult"
				    border
				    style="width: 100%">
				      	<el-table-column
					        prop="code"
					        label="是否必填">
				      	</el-table-column>
				      	<el-table-column
				        	prop="type"
				        	label="类型">
				        	<!-- <template scope="scope">
					    		<div class="table_msg">	
					    			{{scope.row.msg}}
					    		</div>
					    	</template> -->
				      	</el-table-column>
				      	<el-table-column
				        	prop="msg"
				        	label="说明">
				        	<!-- <template scope="scope">
					    		<div class="table_msg">	
					    			{{scope.row.msg}}
					    		</div>
					    	</template> -->
				      	</el-table-column>
			    </el-table>
			</template>
		</div>
        <h3 class="doc_main_h3">tags类型说明</h3>
        <div class="table_box">
			<template>		<!--:span-method="objectSpanMethod"-->
			    <el-table
				    :data="tableDataTags"
				    border
				    style="width: 100%">
				      	<el-table-column
					        prop="code"
					        label="是否必填">
				      	</el-table-column>
				      	<el-table-column
				        	prop="type"
				        	label="类型">
				        	<!-- <template scope="scope">
					    		<div class="table_msg">	
					    			{{scope.row.msg}}
					    		</div>
					    	</template> -->
				      	</el-table-column>
				      	<el-table-column
				        	prop="msg"
				        	label="说明">
				        	<!-- <template scope="scope">
					    		<div class="table_msg">	
					    			{{scope.row.msg}}
					    		</div>
					    	</template> -->
				      	</el-table-column>
			    </el-table>
			</template>
		</div>
        <h3 class="doc_main_h3">返回值示例</h3>
        <pre class="doc_main_pre"><code class="doc_main_code">//成功：
  {
    "error_code": 0,
    "error_msg": "OK",
    "tags": [
      {
        "tag": "雪碧",
        "confidence": 85
      },
      {
        "tag": "七喜",
        "confidence": 57
      }
    ]
  }

//失败：
  {
    "error_code": 10001,
    "error_msg": "AUTHORIZATION_ERROR < APPLICATION_TABLE_VISIT_FAIL >"
  }</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../components/authorityErrorCode'
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
		},
		data(){
			return{
				isPathData:['物体识别','SKObjects-API','API'],
				tableDataParameter:[//请求参数表
					{
						"code":"必须",
						"key":"api_key",
						"type":"String",
						"msg":"调用次API的API Key",
						"rowspan":1,
						"colspan":1,
					},
					{
						"code":"必须",
						"key":"api_secret",
						"type":"String",
						"msg":"调用此API的API Secret",
						"rowspan":1,
						"colspan":1,
					},
					{
						"code":"二选一",
						"key":"image_url",
						"type":"String",
						"msg":"图片的URL",
						"rowspan":2,
						"colspan":1,
					},
					{
						"code":"二选一",
						"key":"api_secret",
						"type":"String",
						"msg":"图片数据",
					},
				],
				tableDataResult:[//返回值
					{
						"code":"error_code",
						"type":"int",
						"msg":"错误状态码",
					},
					{
						"code":"error_msg",
						"type":"String",
						"msg":"错误消息",
					},
					{
						"code":"tags",
						"type":"Array",
						"msg":"图像标签数组",
					},
				],
				tableDataTags:[
					{
						"code":"tag",
						"type":"String",
						"msg":"图像标签名称",
					},
					{
						"code":"confidence",
						"type":"int",
						"msg":"图像标签置信度整数，范围[0,100]，值越大置信度越高",
					},
				]
			}
		},
		watch:{

		},
		methods:{
			//请求参数
			objectSpanMethodParameter({ row, column, rowIndex, columnIndex }){
				if (columnIndex === 0) {
			        if (row.rowspan) {
			            return {
			              rowspan: row.rowspan,
			              colspan: row.colspan
			            };
			        } else {
			            return {
			              rowspan: 0,
			              colspan: 0
			            };
			        }
		        }	
			},
		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../less/index.less';
	.sk_objects_api{
		//margin:5px 0 30px 30px;
		.table_box{
			width:100%;
			margin:10px 0;
		}
		thead{
			tr{
				th{
					padding:15px 0;
					background: #F5F7FA;
					color:#333;
				}
			}
			
		}
		.cell{
			text-align: center;
			color:#2c3e50;;
			.table_msg{
				text-align: left;
				.table_msg_list{
					padding: 2px 0;
				}
			}
		}
		tbody{
			td{
				padding:8px 0;
			}
		}	
		
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skobjectsapi/SKObjectsApi.vue